import { ScIndicator } from './styled';

const LiveIndicator = () => (
  <ScIndicator>
    <div className="red-dot" />
    <div className="pulse" />
    <div className="pulse two" />
  </ScIndicator>
);

export default LiveIndicator;
